import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Stack from '@mui/material/Stack';

import AppDashboard from '../AppDashboard';
import CustomSelect from '../../components/common/CustomSelect';
import WeeklyProviderActuationSummaryReport from '../../components/reports/WeeklyProviderActuationSummaryReport';
import {useGetReportsQuery} from '../../redux/services/reportApi';

const reportScreens = () => ([
  {
    key: 'weekly_provider_actuation_summary',
    name: 'Provider Actuation (Weekly Summary)',
    Component: WeeklyProviderActuationSummaryReport,
  },
]);

const parseSearchParams = (searchParams) => {
  const filter = searchParams.entries().reduce((acc, [key,value]) => (
    ['report_name'].includes(key)
    ? acc
    : {...acc, [key]: value}
  ), {});
  return filter;
};

const handleFilterChange = ({setFilter, setSearchParams}) => filter => {
  console.log('Applying filters:', filter);
  setSearchParams(filter || {});
  setFilter(filter || {});
};

const ViewReportPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState(parseSearchParams(searchParams));
  const [report, setReport] = useState('weekly_provider_actuation_summary');
  const reports = reportScreens();
  const {Component, name} = reports.find(r => r.key === report);
  const query = useGetReportsQuery({report_name: report, ...filter});
  return (
    <AppDashboard
      title={name}
      loading={query.isLoading || query.isFetching}
    >
      <Stack 
        direction='row' 
        spacing={1} 
        style={{paddingLeft: '1.8em', marginBottom: '2em'}}
      >
        <CustomSelect
          options={reports.map(r => ({value: r.key, label: r.name}))}
          defaultValue={report}
          onChange={(e, val) => setReport(e.target.value)}
          label="Select Report"
          maxWidth='300px'
          fullWidth
        />
      </Stack>
      <Component
        filter={filter}
        reportData={query?.data?.data}
        onFilterChange={handleFilterChange({setFilter, setSearchParams})}
      />
    </AppDashboard>
  );
};

export default ViewReportPage;